import { List } from "@radix-ui/react-tabs";

import { styled } from "../../theme";

export const TabsList = styled(List, {
  display: "flex",
  gap: "$3",
});
